/**
 * 소속별 발주 전략 레지스트리
 *
 * 신규 업체 추가 시 Base 를 상속한 클래스를 만들고 STRATEGIES
 * 배열에 등록만 하면 된다. matches() 가 true 를 반환하는 첫 전략을 사용.
 *
 * 사용 예:
 *   import { getSosokStrategy } from '../F/Baljoo/Sosok/Registry';
 *   const strategy = getSosokStrategy(ORDER.order_sosok);
 */
import Mercury from './Mercury';
import Default from './Default';

const STRATEGIES = [
    new Mercury(),
    // 새 전략 등록 위치 (Default 는 항상 마지막)
    new Default(),
];

export function getSosokStrategy(sosok) {
    return STRATEGIES.find(s => s.matches(sosok)) || STRATEGIES[STRATEGIES.length - 1];
}
